import {wonBetBlock, loseBetBlock, pendingBetBlock} from '../../constants/canvasConfig';
import {roundsInfoStore} from "../../store";
import { betBlock } from './betBlockDrawer';
import {getGameCanvasStandards} from "../../helpers/gameCanvasHelper";

export const drawBetsHistory = () => {
  const {canvas, ctx} = getGameCanvasStandards();
  const {betsHistory, concentrationDiff, chartStartPoint, presentPoint} = roundsInfoStore;

  const betBlocksByStatus = [
    loseBetBlock,
    wonBetBlock,
    pendingBetBlock
  ];

  let order = 1;
  for (const roundId in betsHistory) {
      betsHistory[roundId].forEach((betInfo)=>{
        const betBlockData = {
          x: chartStartPoint + order*100,
          y: canvas.height - (betInfo.point * 10 - concentrationDiff) - 50,
          odd: betInfo.odd,
          amount: betInfo.amount,
          w: 100,
          h: 50,
        };

        betBlock(betBlockData, betBlocksByStatus[betInfo.status]);
    })
    order++;
  }

  //veil on history bet blocks
  const veilGrd = ctx.createLinearGradient(0, 0, presentPoint.x, 0);
  veilGrd.addColorStop(0,'rgba(0,0,0,0.9)');
  veilGrd.addColorStop(1,'rgba(0,0,0,0)');
  ctx.fillStyle = veilGrd;
  //ctx.fillRect(0, 0, presentPoint.x, canvas.height);
}
